import React from 'react';

import css from './ClientsPage.module.css';
import ClientsComponent from "../../components/clientsSection/ClientsComponent/ClientsComponent";


const ClientsPage = () => {
    return (
        <section className={css.wrap}>
            <ClientsComponent/>
        </section>
    );
};

export {ClientsPage};